import React from 'react';
import { WindowCalculator } from './components/WindowCalculator';
export function App() {
  return <WindowCalculator data-id="element-0" />;
}